import { CreateBase, Form, useGetIdentity } from "ra-core";
import { useSearchParams } from "react-router";
import { Card, CardContent } from "@/components/ui/card";

import { FormToolbar } from "../layout/FormToolbar";
import { ActivityInputs } from "./ActivityInputs";

export const ActivityCreate = () => {
  const { identity } = useGetIdentity();
  const [searchParams] = useSearchParams();
  const prospectIdParam = searchParams.get("prospect_id");
  const prospectId = prospectIdParam ? Number(prospectIdParam) : undefined;

  return (
    <CreateBase redirect="list">
      <div className="mt-2 flex max-w-2xl">
        <Form
          className="flex-1"
          defaultValues={{
            sales_id: identity?.id,
            prospect_id: prospectId,
            type: "follow_up_call",
            priority: "normal",
            all_day: false,
          }}
        >
          <Card>
            <CardContent>
              <ActivityInputs />
              <FormToolbar />
            </CardContent>
          </Card>
        </Form>
      </div>
    </CreateBase>
  );
};
